import styled from 'styled-components';
import imgBg from 'assets/img/background-login.jpg'; 


export const LandingContainer = styled.div`
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1)), url(${imgBg});
  background-position: center;
  background-size: cover;
  `;




export const LandingItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100vh;
  max-height: 100%;
  padding: 0 2rem;
  width: 650px;
  text-transform: uppercase;
  line-height: 1;
  font-weight: 700;

  @media screen and (max-width: 640px) {
    width: 100%;
  }
`;

export const LandingH1 = styled.h1`
font-family: 'Josefin Sans', sans-serif;
font-size: clamp(2.5rem, 10vw, 5rem);
margin-bottom: 3rem;
color:#DADEDF;
letter-spacing: 3px;
`;



export const LandingP = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 10vw, 3rem);
  margin-bottom: 10rem;
  padding: 0 2rem;
  letter-spacing: 0.5px;

  color:#F57C00;
`;
